import * as React from 'react';
import { Image } from '@cian/ui-kit';
import { Gallery } from '../../components/Gallery';
import { FeatureLabels } from '../../components/FeatureLabels';
import { Carousel } from '../../components/Carousel';
import { IVillageVideo } from '../../types/village';
import { useLabels } from './hooks/useLabels';

export interface IGalleryContainerProps {
  images: string[];
  videos?: IVillageVideo[] | null;
  deviceType?: 'desktop' | 'mobile';
}

export const GalleryContainer: React.FC<IGalleryContainerProps> = ({ images, videos, deviceType }) => {
  const labels = useLabels(videos);

  return (
    <Gallery>
      {images.length ? <Carousel images={images} deviceType={deviceType} /> : <Image borderRadius="4px" src="" />}
      {!!labels.length && <FeatureLabels labels={labels} deviceType={deviceType} />}
    </Gallery>
  );
};
